<template>
  <div class="">
    <div>
      <navbar/>
    </div>
    <app-main/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppMain from '../layout/components/AppMain'
import Navbar from '../layout/components/Navbar'
import AppFooter from '../layout/components/AppFooter'

export default {
  name: "index",
  components: {
    AppMain,
    Navbar,
    AppFooter
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/layout/index.vue